import AnalyticsHelper from '../../utils/analytics-helper.js';
export default class DealerDetails {
    constructor(el){
        this.el = el;
        this.country = el.dataset.country;
        this.division = el.dataset.division;
        this.uri = el.dataset.uri;
        this.back = el.querySelector('.back-link');
        this.bind();
        this.lastViewed();
    }
    
    lastViewed(){
        window.localStorage.setItem(`${this.country}_${this.division}_dealer_last_viewed`, `${this.uri}`);
    }

    bind(){
        this.back?.addEventListener('click', (e) => {
            AnalyticsHelper.push(this.back);
            if(document.referrer === e.currentTarget.href){ 
                e.preventDefault();
                window.history.back();
            }
        });
    } 
}